import { JET_PROGRAMS } from "@/lib/format";

export const ClientTypeBadge = ({ trip, testId, showOnDemand = false }) => {
  const base = "inline-flex items-center px-2.5 py-1 text-[0.6rem] tracking-[0.18em] uppercase border whitespace-nowrap";
  if (trip.client_type === "jet_card") {
    const p = JET_PROGRAMS[trip.jet_card_program];
    return <span className={`${base} ${p?.cls || ""}`} data-testid={testId}>Jet Card · {p?.label}</span>;
  }
  if (!showOnDemand) return null;
  return <span className={`${base} bg-white/[0.04] text-zinc-300 border-white/15`} data-testid={testId}>On Demand</span>;
};
